var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5464_60996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2721 17L10.6695 9.13137C10.3875 8.73535 10.2465 8.53735 10.0839 8.46316C9.94094 8.3979 9.7869 8.3979 9.64389 8.46316C9.48131 8.53735 9.34033 8.73535 9.05835 9.13137L7.10936 11.8686C6.82738 12.2646 6.6864 12.4627 6.52382 12.5368C6.38082 12.6021 6.22677 12.6021 6.08377 12.5368C5.92119 12.4627 5.7802 12.2646 5.49823 11.8686L2.03165 7M16.2721 17H11.288M16.2721 17V10",
    stroke: "#DA4733",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5464_60996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0886,
    height: 24,
    fill: "white",
    transform: "translate(0.607605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlty);
export default __webpack_public_path__ + "static/media/blty.67419ce4b24e65acc64834b9debc418c.svg";
export { ForwardRef as ReactComponent };